import Button from 'components/Button/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteText,
  getSelectedText,
  setSelectedText,
  updateText,
} from 'store/lixaniPaint/slices/drawingToolSlice';

export const TextSettings = () => {
  const dispatch = useDispatch();
  const selectedText = useSelector(getSelectedText);

  const handleTextColorChange = (e) => {
    if (!selectedText) return;
    dispatch(setSelectedText({ ...selectedText, textColor: e.target.value }));
    dispatch(updateText(selectedText));
  };

  const handleFontSizeChange = (e) => {
    if (!selectedText) return;

    dispatch(
      setSelectedText({ ...selectedText, fontSize: parseInt(e.target.value) })
    );
    dispatch(updateText(selectedText));
  };

  const handleFontFamilyChange = (e) => {
    if (!selectedText) return;

    dispatch(setSelectedText({ ...selectedText, fontFamily: e.target.value }));
    dispatch(updateText(selectedText));
  };

  const handleDeleteText = () => {
    if (selectedText) {
      dispatch(deleteText({ id: selectedText.id }));
      dispatch(setSelectedText(null));
    }
  };

  return (
    <div style={{ padding: '16px', color: 'white' }}>
      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          Tekstin väri
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <input
            type="color"
            value={selectedText?.textColor || '#000000'}
            onChange={handleTextColorChange}
            style={{
              width: '40px',
              height: '32px',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '6px',
              backgroundColor: 'transparent',
              cursor: 'pointer',
            }}
          />
          <span style={{ fontSize: '13px', opacity: 0.8 }}>
            {selectedText?.textColor || '#000000'}
          </span>
        </div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          Fonttikoko
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <input
            type="range"
            min="8"
            max="48"
            value={selectedText?.fontSize || 16}
            onChange={handleFontSizeChange}
            style={{
              flex: 1,
              height: '6px',
              borderRadius: '3px',
              background: 'rgba(255,255,255,0.2)',
              outline: 'none',
              cursor: 'pointer',
            }}
          />
          <span
            style={{
              minWidth: '40px',
              fontSize: '13px',
              fontWeight: '500',
              padding: '4px 8px',
              backgroundColor: 'rgba(255,255,255,0.1)',
              borderRadius: '4px',
              textAlign: 'center',
            }}
          >
            {selectedText?.fontSize || 16}px
          </span>
        </div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          Fontti
        </label>
        <select
          value={selectedText?.fontFamily || 'Arial'}
          onChange={handleFontFamilyChange}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '6px',
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: 'white',
            fontSize: '14px',
            cursor: 'pointer',
          }}
        >
          <option
            value="Arial"
            style={{ backgroundColor: '#1687af', color: 'white' }}
          >
            Arial
          </option>
          <option
            value="Helvetica"
            style={{ backgroundColor: '#1687af', color: 'white' }}
          >
            Helvetica
          </option>
          <option
            value="Times New Roman"
            style={{ backgroundColor: '#1687af', color: 'white' }}
          >
            Times New Roman
          </option>
          <option
            value="Courier New"
            style={{ backgroundColor: '#1687af', color: 'white' }}
          >
            Courier New
          </option>
          <option
            value="Verdana"
            style={{ backgroundColor: '#1687af', color: 'white' }}
          >
            Verdana
          </option>
        </select>
      </div>

      {selectedText && (
        <Button
          onClick={handleDeleteText}
          color="danger"
          fullWidth
          size="small"
          style={{ marginTop: '8px' }}
        >
          Poista teksti
        </Button>
      )}
    </div>
  );
};
